/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { Colors, Sizes } from "../../styles";

const SliderToggles = ({
	slidesCount,
	currentSlide,
	toggleNexSlide,
	togglePrevSlide,
	isMobile
}) => {

	return (
		<Toggles>
			<PrevArrow
				aria-label="slider previous arrow"
				isDisabled={isMobile? currentSlide === 1 : currentSlide === 4}
				onKeyPress={togglePrevSlide}
				onMouseDown={(e) => {
					e.preventDefault();
					togglePrevSlide();
				}}
			/>
			<Numbers>
				<Number>{currentSlide}</Number>
				<hr />
				<Number>{slidesCount}</Number>
			</Numbers>
			<NextArrow
				aria-label="slider next arrow"
				isDisabled={currentSlide > slidesCount - 1}
				onKeyPress={toggleNexSlide}
				onMouseDown={(e) => {
					e.preventDefault();
					toggleNexSlide();
				}}
			/>
		</Toggles>
	);
};

SliderToggles.propTypes = {
	slidesCount: PropTypes.number,
	currentSlide: PropTypes.number,
	toggleNexSlide: PropTypes.func,
	togglePrevSlide: PropTypes.func,
	isMobile: PropTypes.bool
};

export default SliderToggles;

const Toggles = styled.div`
	display: flex;
	padding-top: 5.5rem;
	justify-content: flex-end;
	align-items: center;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		padding-top: 2.4rem;
	}
`;

/* 
the important flags are added here purely for the editor experience
WordPress forces button styles to show up on the editor side
as of now !important is the only thing that stops that from happening 
*/
const Arrow = styled.button`
	background: none !important;
	padding: 0;
	height: 3rem;
	width: 5rem;
	display: flex;
	align-items: center;
	pointer-events:  ${(props) => (props.isDisabled ? "none" : "all")};
	cursor: ${(props) => (props.isDisabled ? "default" : "pointer")};
	opacity: ${(props) => (props.isDisabled ? "0.5" : "1")};

	&:hover,
	&:focus {
		background: none !important;
		box-shadow: none !important;
	}

	&:focus {
		border: 1px solid blue;
	}
`;

const PrevArrow = styled(Arrow)`
	&::after {
		content: url(${mainScript.assetPath +
		"images/svg/icons/icon-chevron-left.svg"});
		transition: all 0.2s ease-in;
		margin-top: 4px;
	}
`;

const NextArrow = styled(Arrow)`
	justify-content: center;

	&::after {
		content: url(${mainScript.assetPath +
		"images/svg/icons/icon-chevron-right.svg"});
		transition: all 0.2s ease-in;
		margin-top: 4px;
	}
`;

const Numbers = styled.div`
	display: flex;
	align-items: center;
	gap: 2.2rem;
	height: 22px;

	hr {
		width: 101px;
		margin: 0;
	}
`;
const Number = styled.span`
	width: 2rem;
	font-weight: 500;
	font-size: 2.1rem;
	line-height: 2.6rem;
	color: ${Colors.base.white};
`;
